// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InstagramFilledSvg from "@ant-design/icons-svg/es/asn/InstagramFilled";
import AntdIcon from '../components/AntdIcon';

var InstagramFilled = function InstagramFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InstagramFilledSvg
  }));
};

InstagramFilled.displayName = 'InstagramFilled';
export default React.forwardRef(InstagramFilled);